
import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Zap, Target, Layers } from 'lucide-react';

const StrategicAdvantage: React.FC = () => {
  const advantages = [
    {
      icon: <Shield size={20} />,
      title: "Regulatory Fortress",
      description: "Protective administrative layers for your interests."
    },
    {
      icon: <Zap size={20} />,
      title: "Frictionless Motion",
      description: "Standardized workflows tailored to local portals."
    },
    {
      icon: <Target size={20} />,
      title: "Precision Execution",
      description: "Zero-error tolerance with proactive alerts."
    },
    {
      icon: <Layers size={20} />,
      title: "Scalable Support",
      description: "Infrastructure that grows with your entity."
    }
  ];

  return (
    <section className="py-16 md:py-24 relative bg-slate-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-[10px] font-bold text-avus-blue uppercase tracking-[0.3em] mb-2">Core Edge</h2>
          <h3 className="text-2xl md:text-3xl font-bold text-avus-navy tracking-tight">Strategic Advantage</h3>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {advantages.map((adv, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.05 }}
              className="bg-white/80 backdrop-blur-lg border border-white p-5 md:p-6 rounded-[1.25rem] md:rounded-[1.75rem] shadow-sm flex flex-col items-start"
            >
              <div className="text-avus-blue mb-4 bg-slate-50 p-2.5 rounded-lg border border-slate-100">
                {adv.icon}
              </div>
              <h4 className="text-sm md:text-base font-bold text-avus-navy mb-1.5">{adv.title}</h4>
              <p className="text-slate-500 text-[11px] md:text-xs font-medium leading-relaxed">
                {adv.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StrategicAdvantage;
